import { useLocation } from 'react-use';
import { logUnknownErrorResponse } from '@hungryroot/o11y';

export function usePromoCodeFromQueryParamsSessionStorage() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  // prevent errors when we're in SSR
  if (typeof window === 'undefined') {
    return null;
  }

  const promoCode = searchParams.get('promo');
  try {
    if (promoCode) {
      window.sessionStorage.setItem('promo', promoCode);
    }
    return window.sessionStorage.getItem('promo');
  } catch (error) {
    logUnknownErrorResponse('Error setting promo code in session storage', {
      key: 'funnel.usePromoCodeFromQueryParamsSessionStorage',
      error,
    });
    return null;
  }
}
